import { TRADE_SOCKET } from '../../constants/LOCALKEYS';
import useSWR from 'swr';
import { DEFAULT_EP_ID } from '../../constants/DEFAULT';
import { useOrderBook } from './orderBook';
import { useTradeList } from './tradeList';
import { useInfo24H } from './info24H';
import useTradeStore from './tradeStore';
import BigNumber from 'bignumber.js';
import { useIndexPrice } from './indexprice';
import { useTradePosition } from './tradePosition';
import { useCallback, useEffect, useState, useRef } from 'react'; // ✅ useRef 추가
import { useChartDataFeed } from './chartDataFeed';
import { useToken } from '../auth/token'; // ✅ userid 추출용
import { message } from 'antd';
import { useExchangeStore } from './exchangeStore';
import { useMitOrder } from './mitorder';
import { useTradeApi } from './tradeApi'; // ✅ Context 기반 API Hook 사용, Demo/Real 자동 선택
import { useTranslation } from 'react-i18next';
import { useFps } from 'react-fps';
import { useLogQueue } from './logQueue';
import throttle from 'lodash/throttle';

import useSound from 'use-sound';
import order from '../../../assets/order.mp3';
import { useTradeModalStore } from './modalStore';
import console from 'node:console';
import { WebSocketHeartbeat } from '../../../utils/websocketHeartbeat';

// WebSocket 인스턴스 생성
let tradeWS: WebSocket | null = null;
let tradeMessage: any = null;
let lastBar: any = null;
let heartbeat: WebSocketHeartbeat | null = null;

const throttleOrderBook: any = [];
const throttleOrderBookInterval = 50;

const lastprice = new Map();
let amtbuffer = 0;
const lastOrderBook = new Map();
let changeload = false;

const bufferTradeList: any = [];
const throttleTradeList: any = [];
const throttleTradeListInterval = 10;
let current = null;
let mitdata: any = {};
let orderworker2: any = [];

let grouplist: any = [];

const joinGroup = (group: string, ep_id?: string) => {
  // ep_id가 undefined이거나 'undefined' 문자열인 경우 기본값 사용
  if (group == 'user' && (!ep_id || ep_id === 'undefined')) {
    ep_id = String(DEFAULT_EP_ID);
  }

  if (!grouplist.includes(ep_id) && ep_id) {
    grouplist.push(ep_id);
  }

  if (tradeWS && tradeWS.readyState === WebSocket.OPEN) {
    tradeWS?.send(`{"type":"join","group": "${group}", "ep_id": "${ep_id}"}`);
  } else {
    setTimeout(() => {
      joinGroup(group, ep_id);
    }, 1000);
  }
};

const leaveGroup = (group: string, ep_id?: string) => {
  if (grouplist.includes(ep_id) && ep_id) {
    grouplist = grouplist.filter((item) => item != ep_id);
  }

  if (tradeWS && tradeWS.readyState === WebSocket.OPEN) {
    tradeWS?.send(`{"type":"leave","group": "${group}", "ep_id": "${ep_id}"}`);
  } else {
    setTimeout(() => {
      leaveGroup(group, ep_id);
    }, 1000);
  }
};

export function useTradeSocket(url) {
  // ✅ useRef 패턴: handleTradeMessage를 ref로 관리하여 클로저 문제 해결
  const handleTradeMessageRef = useRef<any>(null);

  const [orderSound] = useSound(order, { volume: 1 });

  const { currentFps } = useFps(15);
  const [fps, setFps] = useState(0);

  const { data: tradeStore, chart_id } = useTradeStore();

  const { data: tradeModalStore } = useTradeModalStore();

  const { createOrder, token } = useTradeApi(); // ✅ Context 기반 API Hook 사용, Demo/Real 자동 선택
  const { userid } = useToken();
  const { t } = useTranslation();
  const { data: updatechart } = useChartDataFeed();
  const { data: mit, mutate: mutateMit } = useMitOrder();
  const { myip, data: logqueue, popLog } = useLogQueue();
  mitdata = mit;

  // if (logqueue?.length > 0 && token) {
  //   if (tradeWS != null) {
  //     if (tradeWS?.readyState === WebSocket.OPEN) {
  //       const execLog = popLog();
  //       if (execLog) {
  //         tradeWS.send(
  //           `{"type":"LOG", "token":"${token}", "data": ${JSON.stringify(
  //             execLog
  //           )}, "ip": "${myip}" }`
  //         );
  //       }
  //     }
  //   }
  // }

  useEffect(() => {
    if (currentFps >= 50) {
      setFps(120);
    } else if (currentFps > 40) {
      setFps(60);
    } else if (currentFps > 20) {
      setFps(20);
    } else {
      setFps(0);
    }
  }, [currentFps]);

  const sendOrder = useCallback(
    async (
      long_short: string,
      price: number,
      amount: number,
      ep_id: number,
      main_sub: string,
      leverage: number,
      limit_market: string,
      post_only: number,
      reduce_position: number,
      cross_iso: string,
      tpsl: any,
      tp: any,
      tptype: any,
      sl: any,
      sltype: any,
      after: any
    ) => {
      const orderParams = {
        ep_id: ep_id,
        main_sub: main_sub || 'M',
        long_short: long_short,
        cross_iso: cross_iso,
        leverage: leverage,
        reduce_position: reduce_position,
        post_only: post_only,
        limit_market: limit_market,
        price: price,
        amount: amount,
        tpsl: tpsl,
        tp: tp,
        sl: sl,
        tptype: tptype,
        sltype: sltype,
        is_triggered: !!tradeStore?.trigger_type,
      };

      const result = await createOrder(orderParams); // ✅ Context 기반 API Hook 사용, Demo/Real 자동 선택

      // console.log('tradeStore?.trigger_type 3', tradeStore?.trigger_type);

      if (!tradeModalStore?.sound) {
        orderSound();
      }
      //console.log('result', result);

      if (result.result.success) {
        mutateOrderBook();
        mutatePosition();
        after();
        message.success(t('ordersuccess') + '');
      } else {
        message.error(t(result?.result?.message + '') + '');
      }
    },
    [createOrder, tradeStore?.ep_id]
  );

  const { EPs } = useExchangeStore();
  const {
    data: indexPrice,
    getPrice,
    mutate: mutateIndexPrice,
  } = useIndexPrice(tradeStore?.ep_id || DEFAULT_EP_ID);

  const { data: orderbook, mutate: mutateOrderBook } = useOrderBook(
    tradeStore?.ep_id || DEFAULT_EP_ID
  );
  const { pushmutate: mutateTradeList } = useTradeList(
    tradeStore?.ep_id || DEFAULT_EP_ID
  );
  const { data: positionData, mutate: mutatePosition } = useTradePosition();

  const { updateInfo24H: muateInfo24 } = useInfo24H();

  current = tradeStore?.ep_id || DEFAULT_EP_ID;

  // 포지션을 가지고 있는 모든 종목에 대해 소켓 join
  useEffect(() => {
    if (positionData?.open_positions && token) {
      const positionEpIds = [
        ...new Set(
          positionData.open_positions.map((pos: any) => pos.exchange_pairs_id)
        ),
      ];

      positionEpIds.forEach((ep_id: any) => {
        if (ep_id && !grouplist.includes(String(ep_id))) {
          joinGroup('user', String(ep_id));
        }
      });
    }
  }, [positionData?.open_positions, token]);

  useEffect(() => {
    lastBar = null;
    //console.log('tradeSocket', tradeStore?.ep_id)
    if (tradeWS && tradeWS.readyState === WebSocket.OPEN) {
      tradeWS.send(
        `{"type":"join","group": "user", "ep_id": "${current || DEFAULT_EP_ID}"}`
      );
    }
  }, [current]);

  useEffect(() => {
    //console.log('useEffect ep_change', current, chart_id)
    lastBar = null;
    changeload = false; // ✅ 3초 지연 제거: 즉시 false로 변경

    console.log('useEffect ep_change', current, chart_id, changeload);
    // setTimeout 제거 - 3초 지연 불필요
  }, [current, chart_id]);

  const handleOrderBook = useCallback(
    throttle(async (trade, lastPrice) => {
      //Tep_id|숏|롱
      if (!throttleOrderBook[trade?.ep_id]) {
        throttleOrderBook[trade?.ep_id] = true;
        setTimeout(() => {
          throttleOrderBook[trade?.ep_id] = false;
        }, throttleOrderBookInterval);

        const orderbook = lastOrderBook.get(current);
        // console.log('trade?.from', trade?.from)
        if (trade?.from == 'binance') {
          // console.log('mutateOrderBook orderbook', orderbook?.long, orderbook?.short)

          mutateOrderBook({
            long: orderbook?.long,
            short: orderbook?.short,
          });
        } else {
          if (lastPrice != 0) {
            trade.long =
              trade?.long?.filter(
                (longitem) => +longitem?.split('|')[0] <= +lastPrice
              ) || [];
            trade.short =
              trade?.short?.filter(
                (shortitem) => +shortitem?.split('|')[0] >= +lastPrice
              ) || [];
          }
        }
      }
    }, 220 - fps),
    [mutateOrderBook, current, fps]
  );

  //#region 트리거 주문 실행될 조건 확인, 조건 충족 -> 주문 실행
  const handleTradeOrder = useCallback(
    throttle(async (trade) => {
      if (!bufferTradeList[trade?.ep_id]) bufferTradeList[trade?.ep_id] = [];

      setImmediate(() => {
        const mits = mitdata?.['MIT' + trade?.ep_id];

        if (!mits?.length) {
          return;
        }
        for (const mit of mits) {
          // console.log(
          //   'MIT',
          //   mit?.longshort,
          //   +trade?.price >= +mit?.price,
          //   +trade?.price,
          //   +mit?.price
          // );

          if (mit?.trigger_type == 'BIG') {
            // 현재가가 트리거 가격보다 크면
            // console.log('trigger status BIG', +trade?.price, +mit?.trigger_price, mit?.trigger_type)
            if (+trade?.price <= +mit?.trigger_price) {
              // console.log(
              //   'LONG',
              //   trade?.price,
              //   mit?.price,
              //   +trade?.price >= +mit?.price
              // );
              if (!orderworker2.includes(mit)) {
                orderworker2.push(mit);
                sendOrder(
                  mit?.longshort,
                  mit?.price,
                  mit?.amount,
                  trade?.ep_id,
                  mit?.main_sub,
                  mit?.leverage,
                  mit?.limit_market == 'CL' ? 'L' : 'M',
                  mit?.post_only,
                  mit?.reduce_position,
                  mit?.cross_iso,
                  mit?.tpsl,
                  mit?.tp,
                  mit?.tptype,
                  mit?.sl,
                  mit?.sltype,
                  () => {
                    orderworker2 = orderworker2.filter((i: any) => i != mit);
                  }
                );

                mutateMit(
                  mitdata?.['MIT' + trade?.ep_id]?.filter(
                    (i: any) => i != mit
                  ) || [],
                  trade?.ep_id
                );
              }
            }
          } else {
            // 현재가가 트리거보다 작으면
            // console.log('trigger status SML', +trade?.price, +mit?.trigger_price, mit?.trigger_type)
            if (+trade?.price >= +mit?.trigger_price) {
              if (!orderworker2.includes(mit)) {
                orderworker2.push(mit);
                sendOrder(
                  mit?.longshort,
                  mit?.price,
                  mit?.amount,
                  trade?.ep_id,
                  mit?.main_sub,
                  mit?.leverage,
                  mit?.limit_market == 'CL' ? 'L' : 'M',
                  mit?.post_only,
                  mit?.reduce_position,
                  mit?.cross_iso,
                  mit?.tpsl,
                  mit?.tp,
                  mit?.tptype,
                  mit?.sl,
                  mit?.sltype,
                  () => {
                    orderworker2 = orderworker2.filter((i: any) => i != mit);
                  }
                );
                mutateMit(
                  mitdata?.['MIT' + trade?.ep_id]?.filter(
                    (i: any) => i != mit
                  ) || [],
                  trade?.ep_id
                );
              }
            }
          }
        }
      });
    }, 300 - fps),
    [mitdata, EPs, fps]
  );

  const handleTradeMessage = useCallback(
    async (trade) => {
      // ✅ changeload 체크 제거 - 3초 지연 로직 완전 제거
      // if (changeload) {
      //   lastBar = null;
      //   if ((chart_id || current) == trade.ep_id) {
      //     setTimeout(() => {
      //       changeload = false;
      //     }, 3000);
      //   }
      //   return;
      // }

      if (
        (chart_id || current) == trade.ep_id &&
        updatechart?.updatebars !== null &&
        typeof updatechart?.updatebars === 'function'
      ) {
        const resolution = updatechart?.resolution;

        // ✅ 일봉(1D) 로직 - HTS 패턴 적용
        if (resolution === '1D' || resolution === 'D' || resolution === '1d') {
          if (!lastBar) {
            console.log('[tradeSocket] 일봉 lastBar 없음, getBars 대기 중');
            return; // lastBar 필수 (getBars에서 설정)
          }

          const adjustedTimestamp = trade.timestamp + 9 * 3600 * 1000;
          const normalizedTime = Math.floor(adjustedTimestamp / 86400000) * 86400000;

          const currentDate = new Date(adjustedTimestamp).toISOString().split('T')[0];
          const lastBarDate = new Date(lastBar.time + 9 * 3600 * 1000).toISOString().split('T')[0];

          // ✅ amtbuffer 누적 (리셋 전)
          amtbuffer += trade.amount;

          let bar = {
            ep_id: trade?.ep_id,
            time: normalizedTime,
            close: +lastprice.get(trade.ep_id) || trade.price,
            high: +lastprice.get(trade.ep_id) || trade.price,
            low: +lastprice.get(trade.ep_id) || trade.price,
            open: +lastprice.get(trade.ep_id) || trade.price,
            volume: amtbuffer, // 누적된 거래량 사용
          };

          if (currentDate !== lastBarDate) {
            // ✅ 새로운 봉 (날짜 경계)
            const savedBar = { ...bar }; // 복사해서 저장
            console.log('[tradeSocket] 일봉 신규 봉 생성:', savedBar);
            updatechart.updatebars(savedBar);
            lastBar = savedBar;
          } else {
            // ✅ 기존 봉 업데이트
            bar = {
              ...bar,
              time: lastBar.time, // ✅ lastBar.time 유지! (normalizedTime 사용 금지)
              high: Math.max(lastBar.high, bar.high),
              low: Math.min(lastBar.low, bar.low),
              open: lastBar.open,
              volume: lastBar.volume + amtbuffer, // ✅ lastBar.volume + amtbuffer
            };
            console.log('[tradeSocket] 일봉 기존 봉 업데이트:', bar);
            updatechart.updatebars(bar);
            lastBar = bar;
          }

          // ✅ 사용 후 리셋
          amtbuffer = 0;
        } else {
          // ✅ 분봉 로직 (기존 코드)
          const time = +Math.floor(trade.timestamp / 60000) * 60000;

          let bar = {
            ep_id: trade.ep_id,
            time: +time,
            close: +lastprice.get(+trade.ep_id) || trade.price,
            high: +lastprice.get(+trade.ep_id) || trade.price,
            low: +lastprice.get(+trade.ep_id) || trade.price,
            open: +lastprice.get(+trade.ep_id) || trade.price,
            volume: +amtbuffer,
          };
          amtbuffer = 0;
          if (lastBar === null || bar.time > lastBar?.time) {
            updatechart?.updatebars(bar);
            lastBar = bar;
          } else if (bar.time == lastBar?.time) {
            bar = {
              ep_id: +trade.ep_id,
              time: bar.time,
              close: +trade.price,
              high: Math.max(+lastBar.high, +trade.price),
              low: Math.min(+lastBar.low, +trade.price),
              open: lastBar.open,
              volume: lastBar.volume + bar.volume,
            };
            updatechart?.updatebars(bar);
            lastBar = bar;
          } else {
            // console.log('??? BAR');
            updatechart?.updatebars(bar);
            lastBar = bar;
          }
        }
      }
    },
    [updatechart?.updatebars, updatechart?.resolution, chart_id, current, fps, changeload] // ✅ resolution 추가
  );

  // ✅ useRef 패턴: ref에 최신 handleTradeMessage 함수 저장
  useEffect(() => {
    handleTradeMessageRef.current = handleTradeMessage;
  }, [handleTradeMessage]);

  // ✅ resolution 변경 감지: lastBar 리셋
  useEffect(() => {
    if (updatechart?.resolution) {
      const resolution = updatechart.resolution;
      console.log('[tradeSocket] resolution 변경 감지:', {
        resolution,
        hasUpdatebars: typeof updatechart.updatebars === 'function',
        current,
      });

      // lastBar 리셋
      lastBar = null;
      amtbuffer = 0;
    }
  }, [updatechart?.resolution, current]);

  // const handleTradePrice = useCallback(
  //   throttle(async (trade, indexPrice) => {
  //     if (tradeStore?.ep_id === trade?.ep_id) {
  //       if (window.location.pathname.includes('/trade/')) {
  //         window.document.title = `${tradeStore?.pairs || 'EXCHANGE'} - ${
  //           lastprice.get(+trade.ep_id) || 0
  //         }`;
  //       }
  //     }
  //
  //     setImmediate(() => {
  //       mutateIndexPrice(
  //         [{ price: lastprice.get(+trade.ep_id) || 0 }, { price: indexPrice }],
  //         trade.ep_id
  //       );
  //     });
  //   }, 120 - fps),
  //   [fps, lastprice]
  // );

  const handleTradePrice = useCallback(
    throttle(async (trade, newIndexPrice) => {
      const currentPrice = lastprice.get(+trade.ep_id) || 0;

      // ✅ 개선: 현재가만 비교 (indexPrice[1]은 제외)
      // 가격이 실제로 변경되었을 때만 업데이트 (성능 최적화)
      if (new BigNumber(indexPrice?.[0]?.price || 0).isEqualTo(currentPrice)) {
        return;
      }

      mutateIndexPrice(
        [{ price: currentPrice }, { price: newIndexPrice }],
        trade.ep_id
      );
    }, 100),  // ✅ fps 변동 제거, 고정 100ms throttle (성능 안정화)
    [lastprice, indexPrice]
  );

  const throttledInfo24HMap = new Map<number, any>();

  const getThrottledMutateInfo24H = (ep_id: number) => {
    if (!throttledInfo24HMap.has(ep_id)) {
      const throttled = throttle((data) => {
        // console.log('INFO24H', data, ep_id);
        muateInfo24(ep_id, data);
      }, 3000);

      throttledInfo24HMap.set(ep_id, throttled);
    }

    return throttledInfo24HMap.get(ep_id);
  };

  //#region WebSocket 메시지 핸들러
  const onmessage = async (data: any) => {
    try {
      let trade;

      // WebSocket 응답이 문자열인 경우 (텍스트 형식)
      if (typeof data.data === 'string') {
        trade = JSON.parse(data.data);
      }
      // WebSocket 응답이 Blob인 경우 (이전 코드)
      else if (data.data instanceof Blob) {
        const getDATA = await data.data.text();
        trade = JSON.parse(getDATA);
      }
      // 이미 JSON 객체인 경우
      else {
        trade = data.data;
      }

      if (!trade || typeof trade !== 'object') {
        console.error('Invalid trade data:', trade);
        return;
      }

      // ✅ Heartbeat: Pong 메시지 처리
      if (trade.type === 'pong') {
        heartbeat?.receivedPong();
        return; // Pong 메시지는 비즈니스 로직에서 제외
      }

      if (!trade?.type) {
        console.error('Trade data missing type:', trade);
        return;
      }

      if (!trade?.ep_id) {
        // console.error('Trade data missing ep_id:', trade);
        return;
      }

      const lp = getPrice(trade?.ep_id);

      //#region 포지션 데이터 갱신
      if (trade.type == 'REFRESH') {
        if (trade?.userid == userid) {
          mutatePosition();
          console.log('REFRESH', trade);
        }
      } else if (trade.type == 'ALARM') {
        if (trade?.user_id == userid) {
          const EP = EPs?.find((item: any) => item?.id == trade?.ep_id);
          message.warning(
            EP.pairs + ' 지정가 도달 알람 : 가격 : ' + trade?.price
          );
        }
      } else if (trade.type === 'ORDERBOOK') {
        //console.log('ORDERBOOK', trade, current)
        lastOrderBook?.set(trade?.ep_id, trade);
        handleOrderBook(trade, lp);
      } else if (trade.type === 'ORDER') {
        // console.log('ORDER', trade)
        const updateorder = true;
        if (updateorder) {
          let templong = orderbook?.long || [];
          let tempshort = orderbook?.short || [];

          if (trade.long_short == 'L') {
            if (
              orderbook?.long?.find((item) => {
                const temp = item?.split('|');
                item = {
                  price: new BigNumber(temp[0]).toNumber(),
                  amount: new BigNumber(temp[1]).toNumber(),
                };
                return item.price == trade.price;
              })
            ) {
              templong = orderbook?.long.map((item) => {
                const temp = item?.split('|');
                item = {
                  price: new BigNumber(temp[0]).toNumber(),
                  amount: new BigNumber(temp[1]).toNumber(),
                };
                if (+item.price == +trade.price) {
                  return `${trade.price}|${BigNumber(item.amount)
                    .plus(trade.amount)
                    .toNumber()}`;
                } else {
                  return `${item.price}|${item.amount}`;
                }
              });
            } else {
              templong = [
                ...(orderbook?.long || []),
                `${trade.price}|${trade.amount}`,
              ].sort((a, b) => {
                a = BigNumber(a.split('|')[0]).toNumber();
                b = BigNumber(b.split('|')[0]).toNumber();
                return b - a;
              });
            }
          } else {
            if (
              orderbook?.short?.find((item) => {
                const temp = item.split('|');
                item = {
                  price: new BigNumber(temp[0]).toNumber(),
                  amount: new BigNumber(temp[1]).toNumber(),
                };
                return item.price == trade.price;
              })
            ) {
              tempshort = orderbook?.short?.map((item) => {
                const temp = item.split('|');
                item = {
                  price: new BigNumber(temp[0]).toNumber(),
                  amount: new BigNumber(temp[1]).toNumber(),
                };
                if (+item.price == +trade.price) {
                  return `${trade.price}|${BigNumber(item.amount)
                    .plus(trade.amount)
                    .toNumber()}`;
                } else {
                  return `${item.price}|${item.amount}`;
                }
              });
            } else {
              tempshort = [
                ...(orderbook?.short || []),
                `${trade.price}|${trade.amount}`,
              ]?.sort((a, b) => {
                a = BigNumber(a.split('|')[0]).toNumber();
                b = BigNumber(b.split('|')[0]).toNumber();

                return b - a;
              });
            }
          }
          // console.log('mutateOrderBook templong', templong, tempshort)
          mutateOrderBook({
            long: templong || [],
            short: tempshort || [],
          });
        }
      } else if (trade.type === 'TRADE') {
        //amtbuffer += trade.amount\
        if (trade?.ep_id == current) amtbuffer += trade.amount;
        lastprice.set(+trade.ep_id, +trade.price);

        //#region 데이터 갱신 함수들
        // ✅ useRef 패턴: ref를 통해 최신 handleTradeMessage 호출
        handleTradeMessageRef.current?.(trade);
        handleTradeOrder(trade);
        handleTradePrice(trade, indexPrice?.[0]?.price);

        setImmediate(() => {
          if (throttleTradeList[trade?.ep_id] === undefined) {
            throttleTradeList[trade?.ep_id] = false;
          }

          if (!throttleTradeList[trade?.ep_id]) {
            throttleTradeList[trade?.ep_id] = true;
            setTimeout(() => {
              throttleTradeList[trade?.ep_id] = false;

              const tempbuffer = bufferTradeList[trade?.ep_id] || [];
              bufferTradeList[trade?.ep_id] = [];
              mutateTradeList(tempbuffer?.reverse() || [], trade?.ep_id);
            }, throttleTradeListInterval);

            if (bufferTradeList[trade?.ep_id]?.length > 0) {
              const tempbuffer = bufferTradeList[trade?.ep_id] || [];
              bufferTradeList[trade?.ep_id] = [];
              try {
                if (current == trade?.ep_id) {
                  mutateTradeList(tempbuffer?.reverse() || [], trade?.ep_id);
                }
                //mutateOrderBook(tradeStore?.ep_id)
              } catch (e) {
                console.error(e);
              }
            }
          } else {
            if (!bufferTradeList[trade?.ep_id]) {
              bufferTradeList[trade?.ep_id] = [];
            }

            bufferTradeList[trade?.ep_id].push(trade);
          }
        });
      } else if (trade.type === 'INFO24H') {
        if (!trade?.ep_id) {
          // console.error('Trade data missing ep_id:', trade);
          return;
        }
        // console.log('INFO24H', trade, trade.ep_id);
        // muateInfo24(trade.ep_id, trade);

        getThrottledMutateInfo24H(trade.ep_id)(trade);
      }
    } catch (e) {
      console.error('ERROR', e);
      console.log(e);
      console.log('-------------------');
    }
  };

  const { data, mutate } = useSWR<any>(
    TRADE_SOCKET,
    async () => {
      if (tradeWS == null && url) {
        try {
          console.log('START');
          tradeWS = new WebSocket(url);
          tradeWS.binaryType = 'blob';

          tradeWS.onclose = () => {
            console.log('tradeWS close');

            // ✅ Heartbeat 정리
            heartbeat?.stop();
            heartbeat = null;

            tradeWS = null;
            mutate();
          };

          tradeWS.onerror = () => {
            console.log('tradeWS error');
          };

          tradeWS.onopen = () => {
            console.log('tradeWS open');

            // ✅ Heartbeat 시작 (30초 간격, 5초 Pong 대기)
            if (tradeWS) {
              heartbeat = new WebSocketHeartbeat(
                tradeWS,
                () => mutate(), // Pong 타임아웃 시 재연결
                'TradeSocket'
              );
              heartbeat.start(30000, 5000);
            }

            if (tradeWS && tradeWS.readyState === WebSocket.OPEN) {
              tradeWS.send(
                `{"type":"join","group": "user", "ep_id": "${current || DEFAULT_EP_ID}"}`
              );
            }

            grouplist.map((item) => {
              if (tradeWS && tradeWS?.readyState === WebSocket.OPEN) {
                tradeWS?.send(
                  `{"type":"join","group": "user", "ep_id": "${item}"}`
                );
              }
            });
          };

          console.log('tradeWS', tradeWS);
        } catch (e) {
          console.log('tradeWS error', e);
        }
      }

      tradeMessage = onmessage;

      // console.log('tradeMessage', tradeMessage)

      if (tradeWS != null) {
        tradeWS.onmessage = tradeMessage;
      }

      return tradeWS;
    },
    {
      revalidateIfStale: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    data,
    mutate: (onmessage?: any) => {
      return mutate();
    },
    joinGroup: joinGroup,
    leaveGroup: leaveGroup,
  };
}
